module.exports = __webpack_public_path__ + "img/tab-record-active.d2e39367.png";